import * as Husleieapi from '@modules/husleieapi';
import request from 'superagent';

export default class {
  constructor() {
    this.tries = 0;
    this.defaultClient = Husleieapi.ApiClient.instance;

    this.defaultClient.basePath = process.env.VUE_APP_HUSLEIE_API_CLIENT_V1_BASE_URL;
    this.jwtHost = process.env.VUE_APP_AUTH_URL || '';

    /** Add posibility to override API_BASE_URL of static built apps **/
    if ( window.localStorage.getItem('__OVERRIDE_HUSLEIE_API_CLIENT_V1_BASE_URL') )
     this.defaultClient.basePath = window.localStorage.getItem('__OVERRIDE_HUSLEIE_API_CLIENT_V1_BASE_URL');

    /** Add posibility to override AUTH_URL of static built apps **/
    if ( window.localStorage.getItem('__OVERRIDE_AUTH_URL') )
      this.jwtHost = window.localStorage.getItem('__OVERRIDE_AUTH_URL');


    this.APIKeyHeader = this.defaultClient.authentications['APIKeyHeader'];

    try {
      if ('localStorage' in window) {
        const bearer = window.localStorage.getItem('___api_key_husleie_api_v1');
        if (bearer) {
          // eslint-disable-next-line no-console
          console.log('Reusing api key');
          this.APIKeyHeader.apiKey = bearer;
        }
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }

  callSynchronized(...args) {
    const [apiName, apiFunction] = args.shift().split('.');

    if (!(apiName in Husleieapi)) {
      throw new Error(`Could not find API ${apiName} in Husleieapi!`);
    }
    
    const apiInstance = new Husleieapi[apiName]();

    if (!(apiFunction in apiInstance)) {
      throw new Error(`Could not find ${apiFunction} in ${apiName}!`)
    }

    const apiFunctionArgLength = apiInstance[apiFunction].length - 1;
    if (args.length !== apiFunctionArgLength) {
      throw new Error(
        `Wrong number of args? Expected ${apiFunctionArgLength}, got ${args.length}`
      );
    }

    return new Promise((resolve, reject) => {
      apiInstance[apiFunction](...args, (error, data) => {
        if (error && (error.status === 403 || error.status === 401)) {
          // The api returned a 403. Lets try to get a api token...
          if ('localStorage' in window) {
            window.localStorage.removeItem('___api_key_husleie_api_v1');
          }

          let jwt_url = this.jwtHost;
          // Don't include the path if the path already exists in the provided jwtHost
          if (jwt_url.indexOf('/api/jwt') == -1) jwt_url += '/api/jwt';
          // Call /api/jwt to try getting a token
          request
            .post(jwt_url)
            .withCredentials(true)
            .set('X-Ping', 'pong')
            .then(res => {
              this.APIKeyHeader.apiKey = 'Bearer ' + res.body.token;
              window.localStorage.setItem('___api_key_husleie_api_v1', this.APIKeyHeader.apiKey);

              apiInstance[apiFunction](...args, (error, data) => {
                if (error) {
                  reject(error);
                }
                if (data) {
                  resolve(data);
                }
              });
            })
            .catch(jwtError => {
              reject(jwtError);
            })
        } else if (error) {
          reject(error);
        } else {
          resolve(data);
        }
      });
    });
  }

  // Call callback with a error?
  call(...args) {
    const endpoint = args.shift();
    const callback = args.pop();

    if (typeof callback !== 'function') {
      // eslint-disable-next-line no-console
      console.log('Last arg not a callback?');
      return;
    }

    const e = endpoint.split(/\./);
    const apiName = e.shift();
    const apiFunction = e.shift();

    if (!(apiName in Husleieapi)) {
      callback(`Could not find API ${apiName} in Husleieapi!`);
      return;
    }

    const apiInstance = new Husleieapi[apiName]();

    if (!(apiFunction in apiInstance)) {
      callback(`Could not find ${apiFunction} in ${apiName}!`);
      return;
    }

    const expected_args = apiInstance[apiFunction].length - 1;
    if (args.length !== expected_args) {
      // eslint-disable-next-line no-console
      console.log('Wrong number of args? Expected ', expected_args, 'got', args.length);
      return;
    }

    this.tries++;
    if (this.tries > 5) {
      // eslint-disable-next-line no-console
      console.log('BAILING AFTER FIVE TRIES?!');
      this.tries = 0;
      return;
    }

    // eslint-disable-next-line no-console
    console.log(args);

    apiInstance[apiFunction](...args, (error, data, response) => {
      if (error && (error.status === 403 || error.status === 401)) {
        // The api returned a 403. Lets try to get a api token...
        try {
          if ('localStorage' in window) {
            window.localStorage.removeItem('___api_key_husleie_api_v1');
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
        this.fetchAPIToken(endpoint, ...args, callback);
      } else {
        this.tries = 0;
        callback(error, data, response);
      }
    });
  }

  fetchAPIToken(...args) {
    const endpoint = args.shift();
    const callback = args.pop();

    if (typeof callback !== 'function') {
      // eslint-disable-next-line no-console
      console.log('Last arg not a callback?');
      return;
    }

    let jwt_url = this.jwtHost;

    // Don't include the path if the path already exists in the provided jwtHost
    if (jwt_url.indexOf('/api/jwt') == -1) jwt_url += '/api/jwt';

    // Call /api/jwt to try getting a token
    request
      .post(jwt_url)
      .withCredentials(true)
      .set('X-Ping', 'pong')
      .then(res => {
        this.APIKeyHeader.apiKey = 'Bearer ' + res.body.token;
        try {
          if ('localStorage' in window) {
            // eslint-disable-next-line no-console
            console.log('Caching api key');
            window.localStorage.setItem('___api_key_husleie_api_v1', this.APIKeyHeader.apiKey);
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
        this.call(endpoint, ...args, callback);
      });
  }
}
